export const FREE_THROW_MADE_EVENT_ID = 92;
export const TWO_POINTS_SHOT_MADE_EVENT_ID = 93;
export const THREE_POINTS_SHOT_MADE_EVENT_ID = 94;
export const DUNK_EVENT_ID = 100;
export const END_MATCH_EVENT_ID = 123;
